<template>
  <div class="new-reupload">
    <div class="bread">
      <router-link class="bread-item" to="/orders">订单管理</router-link>
      <div class="bread-arrow">&gt;</div>
      <router-link class="bread-item" :to="'/orders/detail/' + params.orderId" v-if="!notPaied">订单详情</router-link>
      <div class="bread-arrow" v-if="!notPaied">&gt;</div>
      <div class="bread-item">资料详情</div>
    </div>

    <div class="upload-container" v-if="applicant">

      <div class="upload-header fixed-header" v-if="fixedHeader">
        <div class="applicant-header">
          <div class="applicant-name" v-text="applicant.applicant_name"></div>
          <div class="identity" v-if="applicant.material">{{applicant.material.identity_id == 5 ? '通用身份' : maps.identity[applicant.material.identity_id]}}</div>
          <div class="fill-remaining-space"></div>
          <span class="remaining" v-if="notPassMaterialTotalCount">
            <span class="count" v-text="notPassMaterialTotalCount"></span>
            <span class="desc">项资料待修改</span>
          </span>
          <el-button type="primary" class="common-button" :class="{'disable-btn': notPassMaterialTotalCount}"
            @click="reVerify(notPassMaterialTotalCount)"
            v-if="applicant.applicant_status === consts.applicant.STATUS.verifyNotPassed_2">重新审核</el-button>
        </div>
      </div>

      <!-- 申请人 -->
      <div class="upload-header">
        <div class="applicant-header">
          <div class="applicant-name" v-text="applicant.applicant_name"></div>
          <div class="identity" v-if="applicant.material">{{applicant.material.identity_id == 5 ? '通用身份' : maps.identity[applicant.material.identity_id]}}</div>
          <div class="fill-remaining-space"></div>
          <span class="remaining" v-if="notPassMaterialTotalCount">
            <span class="count" v-text="notPassMaterialTotalCount"></span>
            <span class="desc">项资料待修改</span>
          </span>
          <el-button type="primary" class="common-button" :class="{'disable-btn': notPassMaterialTotalCount}"
            @click="reVerify(notPassMaterialTotalCount)"
            v-if="applicant.applicant_status === consts.applicant.STATUS.verifyNotPassed_2">重新审核</el-button>
        </div>
      </div>

      <!-- tab 线上订单的时候才显示，线下直接不显示 -->
      <div class="tab-wrap" v-show="order && order.offline === consts.order.OFFLINE.no_0">
        <div>
          <div v-if="applicant.application || havePaperyMaterial" class="tab" :class="{ active: activeTab == 1 }" @click="activeTab = 1">
            电子资料
            <sup class="el-badge__content" v-if="notPassMaterialCountMap.elec" v-text="notPassMaterialCountMap.elec"></sup>
          </div>

          <!-- 有申请表才显示 -->
          <div class="tab" :class="{ active: activeTab == 2}" @click="activeTab = 2" v-if="applicant.application">
            申请表
            <sup class="el-badge__content" v-if="notPassMaterialCountMap.application" v-text="notPassMaterialCountMap.application"></sup>
          </div>

          <!-- 有纸质资料才显示 -->
          <div class="tab" :class="{ active: activeTab == 3}" @click="activeTab = 3" v-if="havePaperyMaterial">
            邮寄资料
            <sup class="el-badge__content" v-if="notPassMaterialCountMap.papery" v-text="notPassMaterialCountMap.papery"></sup>
          </div>
        </div>
      </div>

      <!-- 标签内容 -->
      <div class="tab-content">

        <!-- 电子资料 -->
        <template v-if="activeTab == 1">
          <fliggy-material :applicant="applicant"></fliggy-material>

          <!-- 必备资料 -->
          <div v-if="applicant.material && applicant.material.material_required.length">
            <div class="type-title">必备资料</div>
            <div class="body">

              <!-- 证件照 -->
              <upload-id-photo v-if="applicant.id_photo" :order-id-photo="order.id_photo" :id-photo="applicant.id_photo" :applicant="applicant"
                :order="order" @reviewImage="openImageReview" @saveUploadInputId="saveUploadInputId" :is-reupload="true" @touchIfShowReVerifyBox="ifShowReVerifyBox"></upload-id-photo>

              <!-- 循环处理所有电子资料 -->
              <div class="upload-panel" v-for="material in applicant.material.material_required" :key="material.elec_id">
                <template v-if="material.attr === consts.material.TYPE.elec_0">

                  <!-- 表格 -->
                  <upload-table
                    v-if="material.pattern === consts.material.PATTERN.table_4"
                    :order="order"
                    :applicant="applicant"
                    :material="material"
                    :is-required="true"
                    :is-reupload="true"
                  ></upload-table>

                  <!-- 身份证 -->
                  <upload-id-card v-if="material.pattern === consts.material.PATTERN.idCardOCR_1" :id-card="material" :applicant="applicant"
                    @reviewImage="openImageReview" :is-reupload="true" :order="order"
                    @saveUploadInputId="saveUploadInputId" @updateOrder="successTips"></upload-id-card>

                  <!-- 护照 -->
                  <upload-passport ref="passportRequired" v-if="material.pattern === consts.material.PATTERN.passortOCR_2" :passport="material" :applicant="applicant"
                    @reviewImage="openImageReview" :is-reupload="true" :order="order"
                    @saveUploadInputId="saveUploadInputId" @updateOrder="successTips"></upload-passport>

                  <!-- 婚姻证明 -->
                  <upload-marital v-if="material.pattern === consts.material.PATTERN.marriageCertificate_3" :marital="material" :applicant="applicant"
                    @reviewImage="openImageReview" :is-reupload="true" :order="order"></upload-marital>

                  <!-- 单页资料 -->
                  <upload-single-page :single-page="material" :applicant="applicant" @reviewImage="openImageReview" :is-optional="false"
                    v-if="material.pattern === consts.material.PATTERN.defaul_0 && material.style === consts.material.STYLE.singlePage_0"
                    :is-reupload="true" @refuseUploadChange="refuseUpload" :order="order"></upload-single-page>

                  <!-- 多页资料 -->
                  <upload-multi-page :multi-page="material" :applicant="applicant" @reviewImage="openImageReview" :is-optional="false"
                    v-if="material.pattern === consts.material.PATTERN.defaul_0 && material.style === consts.material.STYLE.multiPage_1"
                    :is-reupload="true" @refuseUploadChange="refuseUpload" :order="order"></upload-multi-page>
                </template>
              </div>


              <!-- 最后一个资料后面的高度和其他不一样，直接用一个空div填充最简单 -->
              <div class="empty-white-more-space"></div>
            </div>
          </div>

          <!-- 辅助资料 -->
          <div v-if="optionalElecMaterialShouldShow">
            <div class="type-title">辅助资料</div>
            <div class="body">

              <!-- 循环处理所有电子资料 -->
              <div class="upload-panel" v-for="material in applicant.material.material_optional" :key="material.elec_id">
                <template v-if="material.attr === consts.material.TYPE.elec_0">

                  <!-- 表格 -->
                  <upload-table
                    v-if="material.pattern === consts.material.PATTERN.table_4"
                    :order="order"
                    :applicant="applicant"
                    :material="material"
                    :is-optional="true"
                    :is-reupload="true"
                  ></upload-table>

                  <!-- 身份证 -->
                  <upload-id-card v-if="material.pattern === consts.material.PATTERN.idCardOCR_1" :id-card="material" :applicant="applicant"
                    @reviewImage="openImageReview" :is-reupload="true" :is-optional="true" :order="order"
                    @saveUploadInputId="saveUploadInputId" @updateOrder="successTips"></upload-id-card>

                  <!-- 护照 -->
                  <upload-passport v-if="material.pattern === consts.material.PATTERN.passortOCR_2" :passport="material" :applicant="applicant"
                    @reviewImage="openImageReview" :is-reupload="true" :is-optional="true" :order="order"
                    @saveUploadInputId="saveUploadInputId" @updateOrder="successTips"></upload-passport>

                  <!-- 婚姻证明 -->
                  <upload-marital v-if="material.pattern === consts.material.PATTERN.marriageCertificate_3" :marital="material" :applicant="applicant"
                    @reviewImage="openImageReview" :is-reupload="true" :is-optional="true" :order="order"></upload-marital>

                  <!-- 单页资料 -->
                  <upload-single-page :single-page="material" :applicant="applicant" @reviewImage="openImageReview" :is-optional="true"
                    v-if="material.pattern === consts.material.PATTERN.defaul_0 && material.style === consts.material.STYLE.singlePage_0"
                    :is-reupload="true" @refuseUploadChange="refuseUpload" :order="order"></upload-single-page>

                  <!-- 多页资料 -->
                  <upload-multi-page :multi-page="material" :applicant="applicant" @reviewImage="openImageReview" :is-optional="true"
                    v-if="material.pattern === consts.material.PATTERN.defaul_0 && material.style === consts.material.STYLE.multiPage_1"
                    :is-reupload="true" @refuseUploadChange="refuseUpload" :order="order"></upload-multi-page>
                </template>
              </div>

            </div>
          </div>
        </template>

        <!-- 申请表 -->
        <template v-if="activeTab == 2">
          <div class="apply-main">
            <div class="application-reject" v-if="notPassMaterialCountMap.application">

              <!-- 资料不完善备注 -->
              <memo class="memo" v-if="applicant.application.memo" :memo-content="applicant.application.memo" :invalid-file-list="applicant.application.invalid_file_set"></memo>
            </div>
            <!-- 申请表 -->
            <application-form
              ref="applicationForm"
              :backend-application-url="applicationUrl"
              :applicant-id="applicant.order_applicant_id"
              :need-ensure="false"
              :with-box-shadow="false"
              :editable="Boolean(applicationEditable)"
              :is-reupload="true"
              @formSubmittdSuccess="applicationFormSubmitted"
            ></application-form>
          </div>
        </template>

        <!-- 纸质资料 -->
        <template v-if="activeTab == 3">
          <reupload-paper-online-list
            v-if="order && applicant.paper_online_status &&applicant.paper_online.length"
            :paper-online="applicant.paper_online"
            @reviewImage="openImageReview">
          </reupload-paper-online-list>

          <upload-papery-material v-if="applicant.material && applicant.material.material_required.length"
            :applicant="applicant" :is-required="true" />

          <upload-papery-material v-if="applicant.material && applicant.material.material_optional.length"
            :applicant="applicant" :is-required="false" />

        </template>
      </div>
    </div>

    <!-- 重新审核提示框 -->
    <el-dialog title="提示" v-model="dialogVisible" size="tiny" :show-close="false">
      <span>资料都修改完啦，现在提交，签证专家可以尽快帮你重新审核哦~~</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="notSubmit">暂不提交</el-button>
        <el-button type="primary" @click="submitNow">重新审核</el-button>
      </span>
    </el-dialog>


    <!-- 暂不上传对话框 -->
    <el-dialog title="提示" v-model="refuseUploadDialog.show" size="tiny" :show-close="false">
      <span>是否确认暂不上传该资料？</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="refuseUploadCancel">取消</el-button>
        <el-button type="primary" @click="refuseUploadSubmit">确定</el-button>
      </span>
    </el-dialog>

    <el-dialog class="review-box" title="图片预览" v-model="imageReviewDialog.open">
      <img :src="imageReviewDialog.src">
    </el-dialog>

    <reupload-papery-material-btn
      v-if="activeTab == 3 && applicant.applicant_status === 2 && !paperyMaterialAllPass && (!!notPassMaterialCountMap.papery || applicant.paper_online_status)"
      :unsubmited="!!notPassMaterialCountMap.papery && !applicant.paper_online_status"
      :fixed="isReuploadPaperyBtnFixd"
      @paperMaterialSumit="paperMaterialSumit"
      @onlineMaterialSumit="showPaperOnline = true">
    </reupload-papery-material-btn>

    <!-- 寄送资料 -->
    <express-type-choose :orderId="order.user_order_id" :expressChooseModal="showAddressBox"
      @modalClose="expressBoxClose" :current-step="1" :applicant="applicant"></express-type-choose>

    <reupload-paper-online-modal
      :material-list="applicant.paper_online"
      :applicant="applicant"
      :order="order"
      :showPaperOnline="showPaperOnline"
      @visibleSync="val => showPaperOnline = val"
      @paperyOnlineSubmited="paperyOnlineSubmited"
      @reviewImage="openImageReview"></reupload-paper-online-modal>

  </div>
</template>

<script>
import extend from 'extend';
import uploadService from '../services/upload-service';
import orderService from '../services/order-service';
import pcdService from '../services/pcd-service';
import applicantConstants from '../constants/applicant-constants';
import materialConstants from '../constants/material-constants';
import orderConstants from '../constants/order-constants';
import utils from '../libs/utils';
import Http from '../libs/http';
import addressUtils from '../libs/address-utils';

import memo from '../components/upload/memo';

import { APPLICANT_IDENTITY_MAP } from '../maps/applicant-maps';

import UploadIdPhoto from '../components/upload/upload-id-photo';
import UploadIdCard from '../components/upload/upload-id-card';
import UploadMarital from '../components/upload/upload-marital-material';
import UploadPassport from '../components/upload/upload-passport';
import UploadSinglePage from '../components/upload/upload-single-page-material';
import UploadMultiPage from '../components/upload/upload-multi-page-material';
import ExpressTypeChoose from '../components/express-type-choose';
import UploadPaperyMaterial from '../components/upload/upload-papery-material';
import ApplicationForm from './application/components/application-form';
import UploadTable from '../components/upload/upload-table';

import IdcardPassportInfoModal from '../components/common/modals/idcard-passport-info-modal/idcard-passport-info-modal';

import uploadFileService from '../services/upload-file-service';

import ReuploadPaperyMaterialBtn from '../components/reupload/reupload-paper-online/reupload-papery-material-btn';
import ReuploadPaperOnlineModal from '../components/reupload/reupload-paper-online/reupload-paper-online-modal';
import ReuploadPaperOnlineList from '../components/reupload/reupload-paper-online/reupload-paper-online-list';
import FliggyMaterial from '../components/upload/ota/fliggy-material.vue';

export default {
  name: 'reupload',
  components: {
    UploadIdPhoto,
    UploadIdCard,
    UploadMarital,
    UploadPassport,
    UploadSinglePage,
    UploadMultiPage,
    ExpressTypeChoose,
    UploadPaperyMaterial,
    ApplicationForm,
    memo,
    IdcardPassportInfoModal,
    ReuploadPaperyMaterialBtn,
    ReuploadPaperOnlineModal,
    ReuploadPaperOnlineList,
    UploadTable,
    FliggyMaterial,
  },
  data() {
    return {
      order: {},
      applicant: {
        paper_online: [],
      },
      pcds: {},
      activeTab: 1, // 当前激活的tab
      havePaperyMaterial: false, // 是否有纸质资料
      showAddressBox: false, // 寄件地址对话框
      dialogVisible: false, // 对话框的显示
      showedDiolog: false, // 是否已经显示过对话框
      isFirstTimeLoadData: true, // 第一次加载数据
      refuseUploadDialog: { // 暂不上传
        show: false,
        data: {},
      },
      fixedHeader: false,
      imageReviewDialog: {
        open: false,
        src: '',
      },
      params: {
        applicantId: +this.$route.params.aid,
        orderId: +this.$route.params.oid,
        canModify: +this.$route.query.canModify,
      },
      consts: {
        material: materialConstants,
        applicant: applicantConstants,
        order: orderConstants,
      },
      maps: {
        identity: APPLICANT_IDENTITY_MAP,
      },
      currentInputId: '',
      showPaperOnline: false, // 展示在线上传资料弹窗
      isReuploadPaperyBtnFixd: true,
    };
  },
  computed: {
    // 申请表链接保护
    applicationUrl() {
      if (this.applicant.application && this.applicant.application.application_url) {
        return this.applicant.application && this.applicant.application.application_url;
      }
      return '';
    },

    // 只有可选的资料中的电子资料有才显示
    optionalElecMaterialShouldShow() {
      if (this.applicant.material) {
        return this.applicant.material.material_optional.filter(({ attr }) => attr === materialConstants.TYPE.elec_0).length > 0;
      }
    },

    // 从下单页面的查看资料过来要强制可以改申请表 || 与神不通过可以改申请表
    applicationEditable() {

      return this.params.canModify || (this.applicant.application.application_status === 3 && this.applicant.applicant_status === 2)
        || (this.applicant.applicant_status === 2 && this.applicant.application.application_status === 2);
    },

    // 不通过的所有资料的总计
    notPassMaterialTotalCount() {
      return this.notPassMaterialCountMap.elec + this.notPassMaterialCountMap.application + this.notPassMaterialCountMap.papery;
    },

    // 待修改的资料数量
    notPassMaterialCountMap() {
      // 没有支付，就是从订单确认页来的，也不显示
      if (this.order.pay_info && !this.order.pay_info.pay_status) {
        return { elec: 0, application: 0, papery: 0 };
      }

      const showTabNumberApplicantStatus = [
        applicantConstants.STATUS.verifyNotPassed_2,
        applicantConstants.STATUS.waittingToVerify_1,
        applicantConstants.STATUS.verifyNotPass_waittingToRefund_17,
        applicantConstants.STATUS.refundSuccess_8,
      ];

      // 不是上面这些状态直接返回
      if (showTabNumberApplicantStatus.indexOf(this.applicant.applicant_status) < 0) {
        return { elec: 0, application: 0, papery: 0 };
      }

      let elecNotPassCount = 0;
      let paperyNotPassCount = 0;
      let applicationNotPassCount = 0;

      // 处理资料
      if (this.applicant.material) {
        // 所有资料
        const allMaterials = this.applicant.material.material_required.concat(this.applicant.material.material_optional);
        allMaterials.forEach((material) => {
          // 电子资料
          if (material.attr === materialConstants.TYPE.elec_0) {
            // 身份证
            if (material.pattern === materialConstants.PATTERN.idCardOCR_1) {
              // 如果是特殊状态, 就不管身份证背面的情况(因为组件里面使用的字段挂在applicant上,所以直接判断组件里面使用的字段)

              if (this.applicant.is_id_card_special) {
                elecNotPassCount += material.upload[0].elec_status === materialConstants.ELEC_STATUS.unqualified_3 ? 1 : 0;
              } else {
                // 不是特殊状态的时候
                const isElecMaterialNotPass = material.upload.some((upload) => {
                  // URL不存在或者状态为待上传、未通过，则不通过
                  if (!upload.url || upload.elec_status === materialConstants.ELEC_STATUS.unqualified_3 || upload.elec_status === materialConstants.ELEC_STATUS.waittingForUploadMaterial_1) {
                    return true;
                  }
                  return false;
                });
                elecNotPassCount += isElecMaterialNotPass ? 1 : 0; // 尽量不要写 Number + Boolean，虽然也可以
              }
            } else {
              const isElecMaterialNotPass = material.upload.some(upload =>

                // upload项目不是临时的(多页资料在前台添加之后会加上一个temp标志)
                // 且状态是资料不完善或者待上传(需补充资料引起)的
                (upload.elec_status === materialConstants.ELEC_STATUS.unqualified_3 ||
                        upload.elec_status === materialConstants.ELEC_STATUS.waittingForUploadMaterial_1)
                          && !upload.temp,
              );

              elecNotPassCount += isElecMaterialNotPass ? 1 : 0; // 尽量不要写 Number + Boolean，虽然也可以
            }
          }

          // 纸质资料
          if (material.attr === materialConstants.TYPE.papery_1) {
            const isPaperyMaterialNotPass = material.express && material.express.length > 0 &&
              material.express[0].paper_status === materialConstants.PAPERY_STATUS.unqualified_4;

            paperyNotPassCount += isPaperyMaterialNotPass ? 1 : 0;
          }
        });
      }

      // 处理证件照
      if (this.applicant.id_photo) {
        // 有可能资料不完善，有可能照片不合格，然后选了自行提供纸质资料，然后再反选，就成了待上传资料了
        const idCardNotPass = this.applicant.id_photo.id_photo_status === materialConstants.PHOTO_STATUS.verifyNotPassed_3
          || this.applicant.id_photo.id_photo_status === materialConstants.PHOTO_STATUS.waittingForUploadMaterial_1;
        elecNotPassCount += idCardNotPass ? 1 : 0;
      }

      // 申请表
      if (this.applicant.application) {
        applicationNotPassCount += this.applicant.application.application_status === materialConstants.APPLY_STATUS.verifyNotPassed_3 ? 1 : 0;
      }

      return { elec: elecNotPassCount, application: applicationNotPassCount, papery: paperyNotPassCount };
    },

    passportMaterial() {
      if (this.applicant && this.applicant.material) {
        // 所有资料
        const allMaterials = this.applicant.material.material_required.concat(this.applicant.material.material_optional);
        return allMaterials.filter(item => item.pattern === materialConstants.PATTERN.passortOCR_2).pop();
      }
      return {};
    },

    paperyMaterialAllPass() {
      if (this.applicant && this.applicant.material) {
        let paperyAllPassed = true;
        const allMaterials = this.applicant.material.material_required.concat(this.applicant.material.material_optional);
        allMaterials.forEach((material) => {
          if (material.express && material.express.length > 0) {
            paperyAllPassed = paperyAllPassed && material.express[0].paper_status === materialConstants.PAPERY_STATUS.qualified_0;
          }
        });
        return paperyAllPassed;
      }
    },

    notPaied() {
      return this.order.order_status <= this.consts.order.STATUS.waittingToPay_3 || this.order.order_status === this.consts.order.STATUS.waittingToSelectGoToEmbassyTime_10;
    },
  },
  methods: {
    // 获取地址
    getAddress: addressUtils.getAddress,

    /**
     * 暂不上传变化
     * @param {Boolean} checked 是否选中
     * @param {Object} material 资料
     */
    refuseUpload(checked, material) {
      // 选中了状态就是待预审, 没选中就待上传
      const status = checked ? materialConstants.ELEC_STATUS.waittingForVerified_2 : materialConstants.ELEC_STATUS.waittingForUploadMaterial_1;

      // 选中了特殊状态就是 暂不上传 否则 需补充资料
      const special_code = checked ? materialConstants.SPECIAL_CODE.temporarilyNotUpload_6 : materialConstants.SPECIAL_CODE.materialRequired_5;

      if (checked) {
        this.refuseUploadDialog.show = true;
        this.refuseUploadDialog.data = { material, special_code, status, checked };
      } else {
        // 取消了就直接发送请求
        uploadFileService.elecSpecialHandle(material.elec_id, this.applicant.order_applicant_id, this.applicant.user_order_id,
          special_code).then(() => {
          // 成功了设置前端状态
          material.upload[0].elec_status = status;
          material.upload[0].special_code = special_code;
        }).catch((e) => {
          if (e) console.log(e);
        });
      }
    },

    // 点了暂不上传对话框的取消
    refuseUploadCancel() {
      this.refuseUploadDialog.show = false;
      this.refuseUploadDialog.data.material.refuseUpload.checked = false;

      if (!this.refuseUploadDialog.data.material.upload[0].url) {
        this.refuseUploadDialog.data.material.upload[0].elec_status = materialConstants.ELEC_STATUS.waittingForUploadMaterial_1;
        this.refuseUploadDialog.data.material.upload[0].special_code = materialConstants.SPECIAL_CODE.materialRequired_5;
      }
    },

    // 点击暂不上传对话框的确定
    refuseUploadSubmit() {
      this.refuseUploadDialog.show = false;

      // 直接更新特殊状态
      uploadFileService.elecSpecialHandle(this.refuseUploadDialog.data.material.elec_id, this.applicant.order_applicant_id,
        this.applicant.user_order_id, this.refuseUploadDialog.data.special_code).then(() => {
        // 成功了设置前端状态
        this.refuseUploadDialog.data.material.upload[0].elec_status = this.refuseUploadDialog.data.status;
        this.refuseUploadDialog.data.material.upload[0].special_code = this.refuseUploadDialog.data.special_code;
        this.refuseUploadDialog.data.material.upload[0].memo = '';
        this.refuseUploadDialog.data.material.upload[0].url = '';

        // 清空
        this.refuseUploadDialog.data = {};
      });
    },

    // 打开图片预览
    openImageReview(imageSrc) {
      if (imageSrc) {
        this.imageReviewDialog.open = true;
        this.imageReviewDialog.src = imageSrc;
      }
    },

    // 重新预审
    reVerify(notPassMaterialTotalCount) {
      if (notPassMaterialTotalCount) return;

      Http.post('/applicant_reverify', {
        order_applicant_id: this.params.applicantId,
      }).then(() => {
        utils.msg.success('已提交重新审核，我们会尽快帮您处理');
        this.goToDetail();
      }).catch((e) => {
        if (e) console.log(e);
      });
    },

    // 跳转到订单详情
    goToDetail() {
      // 因为申请表资料不完善的原因需要这样处理，刷新之后就不能back了
      if (this.$route.params.back) {
        history.back();
      } else {
        this.$router.push({ name: 'orderDetail', params: { oid: this.order.user_order_id } });
      }
    },

    // 填写快递单号弹出框的关闭回调
    expressBoxClose(orderId) {
      // 有订单id代表是寄了，没有就是直接关了
      if (orderId) {
        this.getOrder();
      }

      // 关闭弹窗
      this.showAddressBox = false;
    },

    // 申请表提交了
    applicationFormSubmitted(newApplicationStatus) {
      this.applicant.application = extend(true, {}, this.applicant.application, { application_status: newApplicationStatus });
    },

    // 暂时不提交
    notSubmit() {
      this.dialogVisible = false;
    },

    // 现在提交
    submitNow() {
      this.dialogVisible = false;
      this.reVerify(false);
    },


    // 为申请表处理(!!!这个名字和申请表里面的一个名字相同，如果要改这个名字，申请表那边也要改!!!)
    // refreshData: this.getOrder,

    // 获取当前申请人，如果没有获取到，则直接跳转到之前的页面
    getApplicant() {
      // 获取当前申请人
      let applicantTemp = uploadService.getApplicantInOrderByApplicantId(this.order, this.params.applicantId);

      // 将订单号设置在申请人上面方便传递
      applicantTemp.user_order_id = this.order.user_order_id;

      // 是否有纸质资料
      this.havePaperyMaterial = Boolean(orderService.getApplicantPaperyMaterialCount(applicantTemp));

      // 如果身份证是特殊状态的时候，只有一个upload项，需要在前端补上
      applicantTemp = orderService.addIdCardUploadItem(applicantTemp, applicantTemp.is_id_card_special);

      uploadService.initApplicantElecMaterialDataForUpload(applicantTemp);

      // 初始化特殊字段值
      uploadService.initSpecialAttrValue(applicantTemp);

      // 此处处理的是订单还未支付之前来到重新上传页面，需要可以修改和上传资料
      if (!uploadService.isOrderStatusBeforePay(this.order.order_status)) {
        applicantTemp = orderService.addMultiMaterialUploadItem(applicantTemp);
      }

      // 初始化可选资料的需补充资料
      uploadService.initApplicantOptinalMaterialSpecial(applicantTemp);

      this.applicant = applicantTemp;


      // 判断要不要进来就显示立刻预审的对话框
      this.ifShowReVerifyBox();
    },

    // 判断要不要显示立刻预审的对话框
    ifShowReVerifyBox() {
      this.$nextTick(() => {
        const needShowDialog = this.applicant.applicant_status === applicantConstants.STATUS.verifyNotPassed_2
          && !this.notPassMaterialTotalCount;
        if (needShowDialog) {
          this.dialogVisible = true;
          this.showedDiolog = true;
        }

        // 控制只显示一次
        if (this.isFirstTimeLoadData) {
          this.isFirstTimeLoadData = false;
        }
      });
    },

    // 获取订单
    getOrder() {
      return Http.post('/order_query', { user_order_id: this.params.orderId }).then((data) => {
        this.order = data;

        // 线下订单的话，就直接是邮寄资料tab
        if (this.order.offline === orderConstants.OFFLINE.yes_1) {
          this.activeTab = 3;
        }

        // 获取申请人
        this.getApplicant();
      }).catch((e) => {
        if (e) console.log(e);
      });
    },

    /**
     * 申请表资料不完善的时候，在申请表内部，如果点击了提交会触发一次地址的变化，通过监听这个变化
     * 重新加载数据，然后体现出来的就是申请表的资料不完善消失了
     */
    setApplicationUrlChangeCallback() {
      window.onhashchange = this.getOrder;
    },


    updatePassportInfo() {
      this.$refs.passportRequired && this.$refs.passportRequired[0].getPassprotInfo();
    },

    // 成功修改信息提示函数
    successTips() {
      this.$message({
        message: '修改成功',
        type: 'success',
      });
      this.getOrder().then(() => {
        this.updatePassportInfo();
      }).catch((e) => {
        if (e) console.log(e);
      });
    },

    // 重新调起文件选择弹框
    chooseFileAgain() {
      if (this.currentInputId) {
        const id = `#${this.currentInputId}`;
        const selector = document.querySelector(id);
        selector.click();
        this.currentInputId = '';
      }
    },
    // 保存当前上传input id
    saveUploadInputId(id) {
      this.currentInputId = id;
    },


    // 提交在线上传资料之后重新请求order数据
    paperyOnlineSubmited() {
      this.getOrder();
    },

    // 线下邮寄
    paperMaterialSumit() {
      const expressInfoSubmitted = this.order.applicant.some(item => item.material.material_required.some(material => material.attr === 1 && material.express[0] && material.express[0].paper_status === materialConstants.PAPERY_STATUS.waittingForReceive_2) ||
        item.material.material_optional.some(material => material.attr === 1 && material.express[0] && material.express[0].paper_status === materialConstants.PAPERY_STATUS.waittingForReceive_2));

      if (expressInfoSubmitted) {

        this.$confirm('您已提交邮寄信息，确定该申请人通过线下邮寄补充资料？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
        }).then(() => {
          Http.post('/applicant_paper_offline_submit', {
            order_applicant_id: this.applicant.order_applicant_id,
            user_order_id: this.applicant.user_order_id,
          }).then(() => {
            this.$message.success('提交成功');
            this.expressBoxClose(this.order.user_order_id);
          }).catch((e) => {
            if (e) console.log(e);
          });
        }).catch((e) => {
          if (e) console.log(e);
        });
      } else {

        this.showAddressBox = true;
      }
    },

    // 去到商品详情
    goProductDetail() {
      this.$router.push({
        name: 'product',
        params: {
          visa_product_id: this.order.visa_product_id,
        },
      });
    },

  },
  watch: {
    notPassMaterialCountMap: {
      handler(newVal) {
        if (!newVal.papery && !newVal.application && !newVal.elec) {
          // 判断要不要显示立刻预审的对话框
          this.ifShowReVerifyBox();
        }
      },
      deep: true,
    },
    activeTab(newVal) {
      if (newVal === 3) {
        this.$nextTick(() => {
          const windowHeight = document.documentElement.clientHeight;
          const bodyHeight = document.body.scrollHeight;
          const footerHeight = document.querySelector('#footer').scrollHeight;
          if (windowHeight < bodyHeight - footerHeight) {
            this.isReuploadPaperyBtnFixd = true;
          } else {
            this.isReuploadPaperyBtnFixd = false;
          }
        });
      }
    },
  },
  mounted() {
    window.addEventListener('scroll', () => {
      this.fixedHeader = window.scrollY > 100;

      // 监听滚动事件，显示悬浮栏
      const windowHeight = document.documentElement.clientHeight;
      const bodyScrollTop =
          document.body.scrollTop || document.documentElement.scrollTop;
      const bodyScrollHeight = document.body.scrollHeight;
      if (
        windowHeight + bodyScrollTop <
          bodyScrollHeight - document.querySelector('#footer').scrollHeight
      ) {
        setTimeout(() => {
          this.isReuploadPaperyBtnFixd = true;
        }, 100);
      } else {
        setTimeout(() => {
          this.isReuploadPaperyBtnFixd = false;
        }, 100);
      }
    });
  },
  created() {
    // 改为直接获取订单的方式
    this.getOrder();

    // 设置申请表提交带来的地址变化，然后回调
    this.setApplicationUrlChangeCallback();

    // 这里必需要使用this.$http，因为鉴权的方式和其他不同
    pcdService.getPcd().then(pcds => this.pcds = pcds).catch((e) => {
      if (e) console.log(e);
    });

  },
  beforeDestroy() {

    // 去除监听
    window.onhashchange = null;
  },
};
</script>

<style lang="less">
// 设置badge样式
.new-reupload .upload-container {
  .el-badge__content {
    border-radius: 50%;
    height: 18px;
    width: 18px;
    padding: 0;
    font-size: 12px;
    text-align: center;
    line-height: 18px;
    vertical-align: sub;
    border: none;
  }
  .refuse-to-upload {
    .el-checkbox__label {
      padding-left: 10px;
    }
  }
  .tab-wrap {
    div {
      .tab {
        font-size: 16px;
        color: #777 !important;
        &.active {
          color: #333 !important;
        }
      }
    }
  }
}
</style>

<style lang="less" scoped>
@import '../assets/less/variable';
.new-reupload {
  line-height: 1;
  .bread {
    line-height: inherit;
    margin: 0 auto;
    width: 1000px;
  }
  .upload-container {
    background-color: @bg;
    box-shadow: 0 0 4px #edeef0;
    margin: 0 auto 186px auto;
    width: 1000px;
    .upload-header {
      transition: all .5s;
      &.fixed-header {
        background-color: @lightGray;
        position: fixed;
        left: 0;
        top: 0;
        z-index: 222;
        width: 100%;
        display: flex;
        justify-content: center;
      }
    }
    .applicant-header {
      height: 60px;
      width: 1000px;
      display: flex;
      align-items: center;
      padding: 0 30px;
      background-color: @lightGray;
      .applicant-name {
        font-weight: bold;
        font-size: 20px;
        color: @text-dark;
      }
      .identity {
        color: @text-sliver;
        font-size: 16px;
        margin-left: 30px;
      }
      .remaining {
        font-size: 14px;
        margin-right: 20px;
        .count {
          color: @text-red;
          margin-right: 3px;
        }
        .desc {
          color: @text-sliver;
        }
      }
      .common-button {
        width: 134px;
        height: 34px;
      }
      .disable-btn {
        background-color: rgba(94, 155, 225, .6) !important;
        color: rgba(255, 255, 255, .4) !important;
        border-color: rgba(94, 155, 225, .6) !important;
        cursor: not-allowed !important;
        border-width: 0;
      }
    }
  }

  .tab-content {
    .type-title {
      height: 50px;
      padding: 0 30px;
      display: flex;
      align-items: center;
      font-size: 18px;
      color: @main;
      background-color: @blue-bg;
    }
    .upload-panel+ .upload-panel {
      margin-top: 10px;
    }
    .empty-white-more-space {
      width: 100%;
      height: 10px;
      background-color: @bg;
    }
  }

  // tab头
  .tab-wrap {
    background-color: #fff;

    &>div {
      height: 50px;
      border-bottom: 1px solid #f0f0f0;
      div {
        float: left;
        width: 200px;
        line-height: 50px;
        text-align: center;
        position: relative;
        cursor: pointer;
      }
      .active {
        color: @main;
        box-shadow: inset 0 -2px 0 0 @main;
      }
      div+div:after {
        content: "";
        width: 1px;
        height: 18px;
        background-color: #f0f0f0;
        position: absolute;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
        -ms-transform: translateY(-50%)
      }
    }
  }

  // 申请表
  .apply-main {
    box-shadow: none;
    position: relative;
    .application-reject {
      width: 100%;
      display: flex;
      align-items: center;
      .memo {
        width: 100%;
      }
    }
  }

  // 寄送资料
  .express-box {
    padding: 0 30px;
    background-color: #fff;
    .send-express {
      height: 80px;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 4px;
      background-color: #fbfbfb;
      margin-top: 20px;
      padding-right: 20px;
      .mail-icon {
        width: 70px;
        display: flex;
        justify-content: center;
        align-items: center;
        img {
          width: 18px;
          height: 22px;
        }
      }
      .detail {
        flex: 1;
        padding-right: 20px;
        display: flex;
        flex-direction: column;
        .send-tip {
          color: #333;
          font-size: 14px;
          line-height: 14px;
        }
        .address-info {
          margin-top: 12px;
          font-size: 14px;
          color: #777;
        }
      }
      .send-mail-btn {
        width: 110px;
      }
    }
  }
}
.popup_loading {
  .success_text {
    margin-bottom: 30px;
    .success_pre {
      font-size: 16px;
      color: #333333;
      line-height: 36px;
      font-weight: bolder;
      text-align: center;
    }
    .success_aft {
      color: #6f6f6f;
      line-height: 20px;
      font-size: 14px;
      text-align: center;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Reupload.vue